import { render } from "./SupportRequestCategoryChart.vue?vue&type=template&id=e19c0670&ts=true"
import script from "./SupportRequestCategoryChart.vue?vue&type=script&lang=ts"
export * from "./SupportRequestCategoryChart.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__